import memoize from 'moize'

import arriereBackoffice from '@avantstay/arriere-clients/dist/arriereBackoffice'

const natureSelection = {
  nature: true,
  defaultPriority: true,
  taxonomyId: true,
  caseForm: true,
  creationPolicy: true,
} as const

const TAXONOMY_TASKS_CACHE_MAX_AGE_MS = 60_000

export const getTaxonomyTasks = memoize(
  async () => {
    return arriereBackoffice.queries
      .taxonomy({
        __alias: 'operations_getTaxonomyInputs',
        taxonomyInputs: {
          tasks: {
            taxonomyNodeId: true,
            label: true,
            statuses: {
              statusId: true,
              label: true,
            },
            serviceTypes: {
              taxonomyNodeId: true,
              label: true,
              natures: natureSelection,
              categories: {
                taxonomyNodeId: true,
                label: true,
                natures: natureSelection,
                subcategories: {
                  taxonomyNodeId: true,
                  label: true,
                  natures: natureSelection,
                },
              },
            },
          },
        },
      })
      .then(results => results.taxonomyInputs.tasks)
  },
  { maxAge: TAXONOMY_TASKS_CACHE_MAX_AGE_MS, isPromise: true },
)

export const classifyCaseFromDescription = async (description: string, regionId: string) => {
  return arriereBackoffice.queries
    .taxonomy({
      __alias: 'operations_classifyCaseFromDescription',
      classifyCaseFromDescription: {
        __retry: false,
        __args: { description, regionId },
        subject: true,
        isNewTaxonomy: true,
        newTaxonomy: {
          taxonomyId: true,
          task: true,
          serviceType: true,
          category: true,
          subcategory: true,
          caseForm: true,
          defaultPriority: true,
        },
      },
    })
    .then(results => results.classifyCaseFromDescription)
}

export type CaseClassificationResult = Awaited<ReturnType<typeof classifyCaseFromDescription>>

interface ClassificationOutcome {
  homeId: string
  workOrderId: string
  suggestedTaxonomyId: string
  selectedTaxonomyId: string
}

export const reportClassificationOutcome = async (outcome: ClassificationOutcome) => {
  return arriereBackoffice.mutations
    .taxonomy({
      __alias: 'operations_reportClassificationOutcome',
      reportClassificationOutcome: {
        __retry: false,
        __args: outcome,
      },
    })
    .then(results => results.reportClassificationOutcome)
}
